export default __webpack_public_path__ + "static/media/darran.8035ce78.jpeg";